import HttpServices from "./httpServices";

const service = HttpServices.getInstance();

export default service;
